import React, { Component } from 'react';
import { NavMenu } from '../components/NavMenu';
import { HelpWidget } from '../components/HelpWidget';

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div className="flex flex-col min-h-screen">
        {/* NavMenu fixed at the top */}
        <div className="fixed w-full top-0 z-50">
          <NavMenu />
        </div>

        {/* Main container */}
        <div className="flex mt-14"> 
          {/* Main content */}
          <div className="flex-grow min-h-screen">
            <main>
              {this.props.children}
            </main>
          </div>
        </div>
        <HelpWidget />
      </div>
    );
  }
}
